import { root } from "./modules/util.js";
import { initToast } from "./modules/toast.js";
import { initMenu } from "./modules/menu.js";
import { initReveal } from "./modules/reveal.js";
import { initMarquee } from "./modules/marquee.js";
import { initFlip } from "./modules/flip.js";
import { initCompare } from "./modules/compare.js";
import { initCrowd } from "./modules/crowd.js";
import { initSnake } from "./modules/snake.js";
import { initCalculator } from "./modules/calculator.js";
import { initFaq } from "./modules/faq.js";
import { initForms } from "./modules/forms.js";
import { initCookie } from "./modules/cookie.js";
import { initJump } from "./modules/jump.js";
import { initBackToTop } from "./modules/backtotop.js";
import { initStickyCta } from "./modules/stickycta.js";
import { prepareMotion, initCountUp, initProgress } from "./modules/motion.js";

root.classList.add("js");

const boot = () => {
  initToast();
  initMenu();
  initMarquee();
  prepareMotion();
  initReveal();
  initFlip();
  initCompare();
  initCrowd();
  initSnake();
  initCalculator();
  initFaq();
  initForms();
  initCookie();
  initJump();
  initBackToTop();
  initStickyCta();
  initCountUp();
  initProgress();
};

if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
else boot();
